import { createSelector } from '@reduxjs/toolkit'

import { getUtility } from '../root.selectors'

export const getCollateralManagementSession = createSelector(
  getUtility,
  (utilitySlice) => utilitySlice.collateralManagementSession,
)
